module.exports = __webpack_public_path__ + "static/card-6-6d0e6d5658d4d4eaff3fb8317ba1f728.png";